/* eslint-disable no-unused-vars */
import React, {useState} from "react";
import style from "./footer.module.css";
import { Link } from "react-router-dom";
import insta from "../../../assets/instagram.png";
import twitter from"../../../assets/twitter.png";
import nlogo from "../../../assets/nlogo.png";



const Footer = () => {
  // const history = useNavigate();
  const currentPath = window.location.pathname;
  const [isOpen, setIsOpen] = useState(false);
  const [activeLink, setActiveLink] = useState(`${currentPath}`); // State to track active link


  const closeHandler = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  // const handleLinkClick = (link) => {
  //   setActiveLink(link);
  //   const element = document.getElementById(link);
  //   if (element) {
  //     element.scrollIntoView({ behavior: 'smooth' });
  //   }
  //   closeHandler();
  // };

  return (
    <div className={style.main}>
        <div className={style.header}>
        <div className={style.logoC} onClick={() => window.scrollTo(0, 0)}>
          {/* <span className={style.title}>directoapp</span> */}
        </div>
        <div className={style.items}>
        {/* <Link
            to="https://nublock.xyz/"
            className={activeLink === "contact" ? style.active : style.color}
            onClick={() => handleLinkClick("contact")}
          >
            nuBlock
          </Link> */}
        {/* <Link
            className={activeLink === "individual" ? style.active : ""}
            onClick={() => handleLinkClick("individual")}

          >
            Individual
          </Link> */}
          {/* <Link
            to="https://nuconsortium.xyz/"
            className={activeLink === "business" ? style.active :  style.color}
            onClick={() => handleLinkClick("business")}

          >
            Business
          </Link> */}
          {/* <Link
            className={activeLink === "plugins" ? style.active : ""}
            onClick={() => handleLinkClick("plugins")}
          >
            Plugins
          </Link> */}
          {/* <Link
            to="https://nu0-1.gitbook.io/nu-whitepaper"
            className={activeLink === "contact" ? style.active : ""}
          >
            WhitePaper
          </Link> */}
          <div style={{ display: "flex", flexDirection: "column" }}>
          <Link
            to="https://directoapp.gitbook.io/directoapp.com"
            className={activeLink === "contact" ? style.active : style.color}
          >
            Documents
          </Link>
          <Link
            to="https://t.me/Contact_nublock"
            className={activeLink === "contact" ? style.active : style.color}
            // onClick={() => handleLinkClick("contact")}
          >
            Contact Us
          </Link>
          </div>
        </div>
      </div>   
      <div className={style.linktree}>
        <p className={style.directoapp}> 2025 nuBlock. All Rights Reserved.  </p>
        
        {/* <p className={style.linkedin}> nuBlock   X   Linkedin  </p> */}
        <div className={style.socials}>
        <a
          href="https://nublock.page.link/DDTUJvrhMnfsUWPi7"
          target="_blank"
          rel="noopener noreferrer"
          className={style.nlogo}
        >
          <img alt="img" src={nlogo} className={style.nlogo} />
        </a>
        <a
          href="https://x.com/nuBlockportal_"
          target="_blank"
          rel="noopener noreferrer"
          className={style.twitter}
        >
          <img alt="img" src={twitter} className={style.twitter} />
        </a>
        {/* <a
          href="https://t.me/joinnu"
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}
        >
          <img alt="img" src={telegram} className={style.link} />
        </a> */}
        <a
          href="https://www.instagram.com/nublockportal_"
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}
        >
          <img alt="img" src={insta} className={style.link} />
        </a>
        {/* <a
          href="https://medium.com/@nublock"
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}
        >
          <img alt="img" src={medium} className={style.link} />
        </a> */}
      </div>
      </div>
    </div>
  );
};

export default Footer;
